import { createSelector } from '@ngrx/store';
import { getOneClickState } from '@ordersnproducts/modules/one-click-order/reducers';

export const getOneClickContractState = createSelector(getOneClickState, state => state.contractState);

export const getOneClickContractsAvailable = (index: number) =>
  createSelector(getOneClickContractState, state => state.contractsAvailable[index]);

export const getOneClickContractSelected = createSelector(getOneClickContractState, state => state.selected);

export const getOneClickContractTypeSelected = createSelector(
  getOneClickContractState,
  state => state.contractTypeSelected,
);

export const getOneClickContractLoading = createSelector(getOneClickContractState, state => state.loading);

export const getOneClickInvoicesAvailable = createSelector(getOneClickContractState, state => state.invoicesAvailable);

export const getOneClickInvoiceSelected = (index: number) =>
  createSelector(getOneClickContractState, state => state.invoiceSelected[index]);
